var map = {
	"./en.js": [
		9591,
		591
	],
	"./esp.js": [
		1646,
		646
	],
	"./fr.js": [
		4624,
		624
	],
	"./hun.js": [
		6301,
		301
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9205;
module.exports = webpackAsyncContext;